import banner from "../../../courses/module-2/img7.png";

const modulo7_pt = {
  courseId: "cripto-blockchain",
  id: "modulo-7",
  title:
    "🧩 MÓDULO 7: Aprender e ganhar cripto – Educação com recompensas reais",
  estimatedDuration: "45 minutos",
  format: "Leitura + atividade reflexiva",
  bannerUrl: banner,
  sections: [
    {
      id: "que-es",
      navLabel: "O que é Learn & Earn?",
      title: "🎯 O que é Learn & Earn?",
      content: [
        {
          type: "paragraph",
          text: "Learn & Earn (Aprenda e ganhe) é uma modalidade educativa em que os usuários recebem pequenas recompensas em criptomoedas em troca de aprender sobre projetos Web3.",
        },
        {
          type: "paragraph",
          text: "Em vez de apenas estudar teoria, esse modelo oferece:",
        },
        {
          type: "list",
          items: [
            "Mini-aulas práticas, geralmente em vídeo ou texto interativo",
            "Questionários ou desafios, para testar o que você aprendeu",
            "Recompensas em tokens, enviadas diretamente para sua wallet após concluir cada atividade",
          ],
        },
        {
          type: "paragraph",
          text: "É uma maneira excelente de aprender enquanto ganha, sem necessidade de investimento inicial. Ideal para jovens que estão começando no mundo cripto.",
        },
      ],
    },
    {
      id: "funcionamento",
      navLabel: "Como funciona?",
      title: "📚 Como funciona?",
      content: [
        {
          type: "orderedList",
          items: [
            "Você cria uma conta em uma plataforma que oferece Learn & Earn.",
            "Escolhe uma lição ativa. Exemplo: “O que é Polygon (MATIC)?”",
            "Estuda o conteúdo (vídeo, artigo, infográfico).",
            "Responde um quiz rápido.",
            "Recebe uma pequena quantia daquela criptomoeda (geralmente entre US$1 e US$3 em tokens).",
          ],
        },
        {
          type: "paragraph",
          text: "💡 Essas recompensas ajudam a motivar e também permitem que você pratique como funciona uma wallet, uma rede e a interação com tokens reais.",
        },
      ],
    },
    {
      id: "plataformas",
      navLabel: "Plataformas populares",
      title: "🌐 Plataformas populares",
      content: [
        {
          type: "paragraph",
          text: "✅ Coinbase Learn & Earn",
        },
        {
          type: "list",
          items: [
            "Idioma: Inglês (algumas lições com legendas)n",
            "Recompensas: USDC, MATIC, XLM, entre outras",
            "Requisitos: Verificação de identidade (KYC) + conta ativa na Coinbase",
            "Vantagens: Muito amigável para iniciantes; conteúdo de alta qualidade",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Binance Learn & Earn",
        },
        {
          type: "list",
          items: [
            "Idioma: Espanhol, inglês e outros",
            "Recompensas: Variam conforme o projeto (ALGO, BNB, SUI etc.)",
            "Requisitos: Conta verificada na Binance; algumas campanhas pedem staking de BNB",
            "Vantagens: Lançam campanhas com frequência; plataforma segura e conhecida",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Stellar Quest",
        },
        {
          type: "list",
          items: [
            "Idioma: Inglês (com explicações visuais e didáticas)",
            "Recompensas: XLM (Stellar Lumens)",
            "Requisitos: Criar uma wallet compatível (ex.: Freighter) e completar desafios técnicos",
            "Vantagens: Ideal para quem aprende fazendo; ensina desde o básico até criar e assinar transações na rede Stellar",
          ],
        },
      ],
    },
    {
      id: "consideraciones",
      navLabel: "Cuidados",
      title: "⚠️ O que saber antes de participar?",
      content: [
        {
          type: "list",
          items: [
            "Verifique sempre se o site é oficial. Existem páginas falsas que imitam as plataformas reais.",
            "Nunca compartilhe sua seed phrase (frase semente). Nem mesmo se alguém prometer recompensas maiores.",
            "Leia os termos de cada campanha. Algumas são limitadas por país ou por tempo.",
            "Use e-mails seguros e wallets protegidas. A segurança das suas criptos depende de você!",
          ],
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Atividade",
      title: "📝 Atividade – Aprenda e reflita",
      content: [
        {
          type: "orderedList",
          items: [
            "Escolha uma mini-aula ativa em alguma das plataformas recomendadas.",
            "Complete o quiz e ganhe sua primeira recompensa em cripto.",
            "Depois, responda no seu caderno:",
          ],
        },
        {
          type: "list",
          items: [
            "O que você aprendeu sobre esse projeto?",
            "Foi fácil ou difícil entender o conteúdo?",
            "O que você pretende fazer com a quantia que ganhou?",
            "Você acha que esse modelo incentiva jovens a aprender mais sobre finanças e tecnologia?",
          ],
        },
      ],
    },
    {
      id: "ejemplo",
      navLabel: "Exemplo real",
      title: "📌 Exemplo real",
      content: [
        {
          type: "paragraph",
          text: "🌟 Maria, estudante de 20 anos em Belo Horizonte-MG, completou três lições na Coinbase Learn.",
        },
        {
          type: "paragraph",
          text: "Ganhou US$6 em USDC. Depois, usou o valor para testar sua primeira wallet e fazer uma transferência entre amigos. Nunca havia tido criptomoedas antes.",
        },
        {
          type: "paragraph",
          text: "Hoje, continua aprendendo e já pensa em guardar parte da sua bolsa estudantil em stablecoins.",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase final",
      title: "🧠 Frase final",
      content: [
        {
          type: "paragraph",
          text: "“Na Web3, até seus aprendizados podem ter valor. Cada lição concluída te aproxima da sua liberdade financeira.”",
        },
      ],
    },
  ],
};

export default modulo7_pt;
